export default __webpack_public_path__ + "static/TSBO@2x-e0edef146d8383887bd52613bac4a95c.jpg";